import Image1 from "../../assets/images/d5a94bbd-a626-4c9e-b4d4-7893f21da065.png";
import Image2 from "../../assets/images/da471e1d-72c2-4ab6-ab9f-79d622027c1b.png";
import Image3 from "../../assets/images/28fa2d50-6374-483e-b823-3ab43c12d1d8.png";
import Image4 from "../../assets/images/9f9657c6-aa36-47f3-9a52-6c087e33a60d.png";
import Image5 from "../../assets/images/f4efe526-97d6-4d7e-8ed3-4649f90c9674.png";
import Image6 from "../../assets/images/6e7922dc-887e-4681-8fae-10184e64c0f9.png";

const AuthSideContent = ({ title, features, testimonial }) => {
  return (
    <div className="h-full flex flex-col justify-between">
      <div>
        <h2 className="text-3xl font-bold mb-6">{title}</h2>
        <ul className="space-y-4">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center">
              <div className="rounded-full bg-white/20 p-1 mr-12">
                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        
        {/* Service industry professionals image grid */}
        <div className="mt-12">
          <h3 className="text-lg font-medium mb-15">Trusted by professionals across industries</h3>
          <div className="grid grid-cols-3 gap-4">
            <div className="aspect-square rounded-md overflow-hidden bg-white/10 p-1 border-2 border-white w-85 h-stretch85">
            <img 
                src={Image1} 
                alt="House cleaners" 
                className="w-full h-full object-cover rounded"
              />
            </div>
            <div className="aspect-square rounded-md overflow-hidden bg-white/10 p-1 border-2 border-white w-85 h-stretch85">
            <img 
                src={Image2} 
                alt="Roofing installation" 
                className="w-full h-full object-cover rounded"
              />
            </div>
            <div className="aspect-square rounded-md overflow-hidden bg-white/10 p-1 border-2 border-white w-85 h-stretch85">
            <img 
                src={Image3} 
                alt="Janitors cleaning" 
                className="w-full h-full object-cover rounded"
              />
            </div>
            <div className="aspect-square rounded-md overflow-hidden bg-white/10 p-1 border-2 border-white w-85 h-stretch85">
            <img 
                src={Image4} 
                alt="Power washing" 
                className="w-full h-full object-cover rounded"
              />
            </div>
            <div className="aspect-square rounded-md overflow-hidden bg-white/10 p-1 border-2 border-white w-85 h-stretch85">
            <img 
                src={Image5} 
                alt="Landscapers cutting grass" 
                className="w-full h-full object-cover rounded"
              />
            </div>
            <div className="aspect-square rounded-md overflow-hidden bg-white/10 p-1 border-2 border-white w-85 h-stretch85">
            <img 
                src={Image6} 
                alt="Pool cleaning service" 
                className="w-full h-full object-cover rounded"
              />
            </div>
          </div>
        </div>
      </div>
      
      {testimonial && (
        <div className="mt-16">
          <div className="p-6 bg-white/10 rounded-lg">
            <p className="italic mb-4">{testimonial.quote}</p>
            <div className="flex items-center">
              <div className="w-10 h-10 rounded-full bg-white/30"></div>
              <div className="ml-3">
                <p className="font-medium">{testimonial.name}</p>
                <p className="text-sm opacity-80">{testimonial.role}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuthSideContent;
